import { WebApiActionGet, WebApiActionPost, QueryParams, WebApiItems } from "components/ajax/WebApi";
import rootUrl from "./url";
import { number, string, bool } from "prop-types";

const baseUrl = rootUrl + "hostovani-dlouhodoba/";


export interface HostItem {
    Id: number;
    DatPorizeni: Date;
    HostKlubNazev: string;
    OdData: Date;
    DoData: Date;
    Stav: number;
}

export interface Hostovani {
    id: number;
    clen_id: number;
    clen_idt: number;
    clen_jm: string;
    clen_pr: string;
    dat_porizeni: Date;
    dat_zpracovani?: Date;
    dat_potvrz_ic?: Date;
    zamitnuto_ic: boolean;
    dat_potvrz_kc?: Date;
    zamitnuto_kc: boolean;

    popl_dat_platby?: Date;
    popl_castka: number;
    popl_var_sym: string;
    popl_spec_sym: string;
    popl_cis_uctu: string;

    datum_od: Date;
    datum_do: Date;

    dom_klub_id?: number;
    dom_klub_naz: string;
    host_klub_id?: number;
    host_klub_naz: string;

    stav: number;
}


export const SeznamHostovani = function (): WebApiActionGet<WebApiItems<Hostovani>> {
    return new WebApiActionGet<WebApiItems<Hostovani>>(baseUrl + 'seznam');
}


export const GetSeznamHostovaniClena = function (clenId: number): WebApiActionGet<WebApiItems<HostItem>> {
    return new WebApiActionGet<WebApiItems<HostItem>>(baseUrl + `seznam-clena/${clenId}`);
}


export const GetHostovani = function (hostovaniId: number): WebApiActionGet<Hostovani> {
    return new WebApiActionGet<Hostovani>(baseUrl + `hostovani/${hostovaniId}`);
}


export const PotvrzeniHostovani = function (hostovaniId: number): WebApiActionPost<{}, Hostovani> {
    return new WebApiActionPost<{}, Hostovani>(baseUrl + `potvrzeni/${hostovaniId}`);
}

export const ZamitnutiHostovani = function (hostovaniId: number): WebApiActionPost<{}, Hostovani> {
    return new WebApiActionPost<{}, Hostovani>(baseUrl + `zamitnuti/${hostovaniId}`);
}


export const StornoHostovani = function (hostovaniId: number): WebApiActionPost<{}, Hostovani> {
    return new WebApiActionPost<{}, Hostovani>(baseUrl + `storno/${hostovaniId}`);
}

export const UkonceniHostovani = function (hostovaniId: number): WebApiActionPost<{}, Hostovani> {
    return new WebApiActionPost<{}, Hostovani>(baseUrl + `ukonceni/${hostovaniId}`);
}
